export const SET_JWT = "APP/SET_JWT";
export const CLEAR_JWT = "APP/CLEAR_JWT";
export const SET_MULTIPLE = "APP/SET_MULTIPLE";
